/**
 * エラー文言
 */
export const ERR_LICENSE = "ライセンスが無効です。シリアルコードを確認して下さい。(x)";
export const ERR_LICENSE_MOBILE = "ライセンスが無効です。(x)";
export const ERR_NETWORK = "サーバーへの接続が失敗しました。インターネットの接続を確認して再度お試しください。";
export const ERR_INVALID_USER = "メールアドレスまたは、パスワードが正しくありません。";
export const ERR_USER_LOCKED = "アカウントが無効です。別のアカウントでログインしてください。";
export const ERR_INVALID_SERIAL = "シリアル番号が正しくありません。";
export const ERR_ONETIMEKEY = "ワンタイムキーが無効です。再度ログインして下さい。(x)";
export const ERR_UNKNOWN = "現在、サービスを利用できません。";
export const ERR_SRE = "音声機能を有効にできませんでした。";

/**
 * 画面表示用文言
 */
export const BUTTON_TEXT_LESSON = "レッスンを続ける";
export const BUTTON_TEXT_LEVEL = "レベル0を今すぐ開始";
export const LESSON_STATE = "進行中";

/**
 * マイルストーン用
 */
export const MILESTONE_QUESTION_COUNT = 6;
export const MILESTONE_TITLE = "確認テスト";
export const MILESTONE_TARGET_TITLE = "コアレッスン";

/**
 * key-value設定API用のkey名
 */
export const DATA_SETTING = "data-setting-";
export const DATA_SCORE = "data-score-";
export const DATA_PROGRESS = "data-progress-";
export const DATA_MILESTONE = "data-milestone-";
export const DATA_STUDY_STATE = "data-study-state";

export const DATA_SETTING_SRE_USE = "data-setting-sreUse";
export const DATA_SETTING_GENDER = "data-setting-gender";
export const DATA_SETTING_DIFFICULTY = "data-setting-difficulty";
export const DATA_SETTING_AUTO_SCREEN_TRANSITION = "data-setting-autoScreenTransition";
export const DATA_SETTING_ANSWER_SOUND = "data-setting-answerSound";
export const DATA_SETTING_TEXT_SIZE = "data-setting-textSize";
export const DATA_SETTING_POPUP_DICTIONARY_USE = "data-setting-popupDictionaryUse";

/**
 * Error.vueのbuttonKind
 */
export const ERROR_BUTTON_KIND_LOGIN = "login";
export const ERROR_BUTTON_KIND_SERIAL = "serial";
export const ERROR_BUTTON_KIND_LICENSE = "checklicense";
export const ERROR_BUTTON_KIND_LIBRARY = "library";
export const ERROR_BUTTON_KIND_ACCESSKEY = "getaccesskey";
export const ERROR_BUTTON_KIND_CLOSE = "close";

/**
 * ファイルパス
 */
// 正解音
export const AUDIO_CORRECT = "./static/resource/sound/correct.mp3";
// 不正解音
export const AUDIO_INCORRECT = "./static/resource/sound/incorrect.mp3";
// 音声認識再生音
export const AUDIO_RECOGNITION = "./static/resource/sound/speechPrompt.mp3";
// マスク音
export const AUDIO_MASK = "./static/resource/sound/tileSound.mp3";

/**
 * runmode名
 */
export const RUNMODE_A1 = "A1";
export const RUNMODE_A1O = "A1O";
export const RUNMODE_A1Q = "A1Q";
export const RUNMODE_TILE = "Tile";
export const RUNMODE_STILE = "STile";
export const RUNMODE_P = "P";
export const RUNMODE_PNT = "PNT";
export const RUNMODE_PSPEECH = "PSpeech";
export const RUNMODE_PNTSPEECH = "PNTSpeech";
export const RUNMODE_TDIC = "TDic";
export const RUNMODE_TPRO = "TPro";
export const RUNMODE_B = "B";
export const RUNMODE_BO = "BO";
export const RUNMODE_A3 = "A3";
export const RUNMODE_A3O = "A3O";
export const RUNMODE_NR5 = "NR5";
export const RUNMODE_NR1 = "NR1";
export const RUNMODE_NR2 = "NR2";
export const RUNMODE_NR3 = "NR3";
export const RUNMODE_NR3_NT = "NR3_NT";

/**
 * SREを使用しないrunmode一覧
 */
export const RUNMODE_NOT_USE_SRE = [
  RUNMODE_A1,
  RUNMODE_A1O,
  RUNMODE_A1Q,
  RUNMODE_TILE,
  RUNMODE_STILE,
  RUNMODE_TDIC,
  RUNMODE_TPRO,
  RUNMODE_B,
  RUNMODE_BO,
  RUNMODE_A3,
  RUNMODE_A3O,
  RUNMODE_NR5,
  RUNMODE_NR1,
  RUNMODE_NR2
];

/**
/* 処理間隔（ミリ数）
 */
// 問題の出題間隔
export const QUESTION_INTERVAL = 500;
// 不正解画像の表示時間
export const INCORRECT_INTERVAL = 1000;
// 全問正解時の表示時間
export const ALLCORRECT_INTERVAL = 3000;
// ロングタッチの間隔
export const LONGTOUCH_DURATION = 500;
// スクロールアイコン表示タイムアウト
export const SCROLL_ICON_VISIBLE_TIME = 5000;

/**
 * 正解判定score
 */
export const CORRECT_SCORE = 7;

/**
 * 表示するテキスト言語
 */
export const BASIC_TEXT = "basicText";
export const JAPANESE_TEXT = "japaneseText";

/**
 * カーソルタイプ
 */
// 矢印マーク
export const CURSOR_DEFAULT = "default";
// 指マーク
export const CURSOR_POINTER = "pointer";

/**
 * プラットフォーム名
 */
// Android
export const PLATFORM_ANDROID = "android";

/**
 * パッケージ名
 */
// Docomo版Android
export const PACKAGE_DOCOMO_ANDROID = "com.sourcenext.android.docomo.rosettastone";
// au版Android(先頭から本番/ステージング別言語別共通部分まで)
export const PACKAGE_AU_ANDROID = "com.sourcenext.android.kddi.rosettastone.";

/**
 * モバイルアプリの最新version
 * アップデート通知ダイアログの表示判定に使用
 */
// Docomo版Android
export const VERSION_DOCOMO_ANDROID = 29;

/**
 * HTML5で動作するSafariのメジャーバージョン
 */
export const SAFARI_HTML5_VERSION = 11;

/**
 * fontクラス名
 */
export const FONT_CLASS_28 = "font28";
export const FONT_CLASS_24 = "font24";
export const FONT_CLASS_21 = "font21";
export const FONT_CLASS_18 = "font18";
export const FONT_CLASS_15 = "font15";
export const FONT_CLASS_14 = "font14";

/**
 * ポップアップ辞書設定
 */
export const POPUP_DICTIONARY_SETTINGS = {
  isProdution: process.env.DEPLOY_ENV === "production",
  popupOption: DIC_OPTIONS_DISABLED, // ポップアップ辞書は無効
  popupSpeed: 500,
  language: DIC_LANGUAGE_CODE_ENUS,
  showSetting: true
};

/**
 * テキスト表示設定
 */
export const MAX_LINE_NUMBER = 5;
export const MIN_TYPING_TEXT_AREA_HEIGHT = 64;
export const TYPING_TEXT_AREA_ADJUST_HEIGHT = 5;
export const AUTO_ADJUST_FONT_SIZE = {
  large: {
    min: 14,
    mid: 20,
    max: 26
  },
  middle: {
    min: 14,
    mid: 18,
    max: 20
  },
  small: {
    min: 11,
    mid: 14,
    max: 16
  }
};

/**
 * GoogleAnalyticsイベントフィールド設定値
 */
export const GA_EVENT = Object.freeze({
  GATEGORY: Object.freeze({
    WORD_LIST: "単語リスト"
  }),
  ACTION: Object.freeze({
    CLICK: "押下"
  }),
  LABEL: Object.freeze({
    DICTIONARY: "辞書"
  })
});

/**
 * GoogleAnalyticsページビューの設定値（ポップアップ辞書表示）
 */
export const GA_PAGEVIEW_TITLE = "ポップアップ辞書";
export const GA_PAGEVIEW_PAGE = "/popup";



// WEBPACK FOOTER //
// ./src/mixin/constants.js